import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "stored_value_manager"
};
const _hoisted_2 = {
  class: "base_screen_header"
};
const _hoisted_3 = {
  class: "btn-box"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "tdm_title"
};
const _hoisted_6 = {
  class: "base_main_margin_top"
};
const _hoisted_7 = {
  class: "base_main_header"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "储值金额列表", -1);

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "冻结金额列表", -1);

const _hoisted_10 = {
  key: 0,
  class: "base_main_margin_top"
};
const _hoisted_11 = {
  key: 1,
  class: "base_main_margin_top"
};
const _hoisted_12 = {
  class: "dialog-footer"
};
import StatusBar from "@com/StatusBar.vue";
import { $msg, $box } from "@ui/msg";
import { ref, reactive } from "vue";
import { Search } from "@element-plus/icons-vue";
import useRoute from "@util/router";
import DataCollectTable from "@com/table/DataCollectTable.vue";
import { OP_KEY, COLUMN_TYPE, OPERATIONS, operationsHander } from "@com/table/tableOperations";
import $ from "@util/base";
import api from "@api/deposit";
export default {
  __name: 'DepositManager',

  setup(__props) {
    const route = useRoute();
    route.watchRouter("depositmanager", () => {
      getData();
    });
    const outTime = ref(route.query().outtime || '');
    const outTimeOptions = ref([{
      label: "正序",
      value: "1"
    }, {
      label: "倒序",
      value: "2"
    }]);

    function searchOutTime(val) {
      route.replaceQuery("outtime", val);
    }

    const statusList = reactive([{
      label: "全部",
      value: "all",
      total: 0
    }, {
      label: "待审批",
      value: "1047002",
      total: 0
    }, {
      label: "已通过",
      value: "1047001",
      total: 0
    } // {
    //   label: "已驳回",
    //   value: "1047003",
    //   total: 0,
    // },
    ]);
    const numList = reactive([// {
    //   label: "储值总额",
    //   total: 0,
    //   sel: false,
    // },
    {
      label: "储值余额（元）",
      total: 0,
      sel: "deposit"
    }, {
      label: "冻结余额（元）",
      total: 0,
      sel: "freeze"
    }, {
      label: "储值用户（个）",
      total: 0,
      sel: "user"
    }]);

    function openMoneyList(val) {
      if (val) {
        route.push({
          name: "depositmoneylist",
          query: {
            type: val
          }
        });
      }
    }

    const data = ref([]);
    const total = ref(0);

    function getOperations(data) {
      if (data.validStatus == "1047003") {
        return [OPERATIONS.check, OPERATIONS.del];
      } else {
        return [OPERATIONS.check];
      }
    }

    const depositConfig = {
      showIndex: true,
      operations: {
        label: "操作",
        width: 120,
        operations: getOperations
      },
      column: [{
        label: "姓名",
        prop: "memberName",
        width: 120
      }, {
        label: "账号",
        prop: "memberLoginName"
      }, {
        label: "姓名/单位",
        prop: "persionName",
        width: 130
      }, {
        label: "储值余额（元）",
        prop: "balanceMoney",
        width: 130
      }, {
        label: "操作储值金额（元）",
        prop: "changeMoney",
        width: 160
      }, {
        label: "备注",
        prop: "remark"
      }, {
        label: "操作人",
        prop: "creatorName",
        width: 120
      }, {
        label: "审核状态",
        prop: "validStatusName",
        width: 100
      }, {
        label: "过期时间",
        prop: "depositExpireTime",
        width: 180
      }, {
        label: "操作时间",
        prop: "createTime",
        width: 180
      }]
    };
    const freezeConfig = {
      showIndex: true,
      operations: {
        label: "操作",
        width: 120,
        operations: getOperations
      },
      column: [{
        label: "姓名",
        prop: "memberName",
        width: 120
      }, {
        label: "账号",
        prop: "memberLoginName"
      }, {
        label: "姓名或单位名称",
        prop: "persionName",
        width: 130
      }, {
        label: "储值余额（元）",
        prop: "balanceMoney",
        width: 130
      }, {
        label: "操作储值金额（元）",
        prop: "changeMoney",
        width: 160
      }, {
        label: "备注",
        prop: "remark"
      }, {
        label: "操作人",
        prop: "creatorName",
        width: 120
      }, {
        label: "审核状态",
        prop: "validStatusName",
        width: 100
      }, {
        label: "过期时间",
        prop: "depositExpireTime",
        width: 180
      }, {
        label: "操作时间",
        prop: "createTime",
        width: 180
      }]
    };
    const dialogVisible = ref(false);
    const formRef = ref(null);
    const form = reactive({
      phone: null,
      changeMoney: null,
      depositType: null,
      changeReason: null,
      remark: null,
      depositExpireTime: null
    });

    function show() {
      dialogVisible.value = true;
    }

    function add() {
      show();
    }

    const rules = {
      phone: [{
        required: true,
        message: "请输入用户手机号",
        trigger: "blur"
      }],
      changeMoney: [{
        required: true,
        message: "请输入储值金额",
        trigger: "blur"
      }, {
        type: "number",
        message: "请输入数字"
      }],
      depositType: [{
        required: true,
        message: "请选择金额类型",
        trigger: "change"
      }],
      changeReason: [{
        required: true,
        message: "请输入说明",
        trigger: "blur"
      }],
      remark: [{
        required: true,
        message: "请输入备注",
        trigger: "blur"
      }],
      persionName: [{
        required: false,
        message: "姓名或单位名称",
        trigger: "blur"
      }] // depositExpireTime: [
      //   {
      //     required: true,
      //     message: "请选择失效日期",
      //     trigger: "change",
      //   },
      // ],

    };

    const submitForm = formEl => {
      if (!formEl) return;
      formEl.validate((valid, fields) => {
        if (valid) {
          userStoredValue(form);
        }
      });
    };

    function userStoredValue(data) {
      api.add(data, () => {
        $msg.succ("新增成功");
        dialogVisible.value = false;
        getData();
      });
    }

    const resetForm = formEl => {
      if (!formEl) return;
      formEl.resetFields();
    };

    function openImport() {
      route.push({
        name: "batchdepositimport"
      });
    }

    function openCard() {
      route.push({
        name: "depositecard"
      });
    }

    const opHander = operationsHander();
    opHander.install(OP_KEY.check, data => {
      route.push({
        name: "depositdetails",
        query: {
          type: "show",
          code: data.id
        }
      });
    });
    opHander.install(OP_KEY.delete, data => {
      $box.open("删除确认", `是否删除${data.memberLoginName}账号，该笔储值记录`, () => {
        api.delete(data.id, () => {
          $msg.succ("删除成功");
          getData();
        });
      });
    });
    const type = ref(route.query().type || "deposit");
    const phone = ref(route.query().phone || "");
    const reason = ref(route.query().reason || "");
    const remark = ref(route.query().remark || "");
    const date = ref(route.query().date || []); // const activeName = ref('deposit');

    function tabChange(val) {
      route.replaceQuery("type", val);
    }

    function searchPhone(val) {
      route.replaceQuery("phone", val);
    }

    function searchReason(val) {
      route.replaceQuery("reason", val);
    }

    function searchRemark(val) {
      route.replaceQuery("remark", val);
    }

    function searchDate(val) {
      route.replaceQuery("date", val);
    }

    getData();

    function getData() {
      getList();
      getNum();
      getStatusNum();
    }

    function getList() {
      let routeQuery = route.query();
      api.list({
        depositType: routeQuery.type === "freeze" ? "1048002" : "1048001",
        phone: routeQuery.phone,
        changeReason: routeQuery.reason,
        remark: routeQuery.remark,
        date: routeQuery.date,
        status: routeQuery.status,
        depositExpireTime: routeQuery.outtime,
        page: routeQuery.p,
        size: routeQuery.s
      }, val => {
        total.value = val.total;
        data.value = val.list.map(e => {
          if (e.changeMoney > 0) {
            e.changeMoney = `+${e.changeMoney}`;
          }

          return e;
        });
      });
    }

    function exportData() {
      let routeQuery = route.query();
      api.exportData({
        depositType: routeQuery.type === "freeze" ? "1048002" : "1048001",
        phone: routeQuery.phone,
        changeReason: routeQuery.reason,
        remark: routeQuery.remark,
        date: routeQuery.date,
        status: routeQuery.status,
        depositExpireTime: routeQuery.outtime,
        page: routeQuery.p,
        size: routeQuery.s
      }, val => {
        $.download(val.url, "储值列表导出");
      });
    }

    function delRefuseData() {
      api.delRefuseData(() => {
        $msg.succ("删除成功");
        getData();
      });
    }

    function getNum() {
      api.num(val => {
        statusData(val, "num");
      });
    }

    function getStatusNum() {
      let routeQuery = route.query();
      api.statusNum({
        phone: routeQuery.phone,
        changeReason: routeQuery.reason,
        remark: routeQuery.remark,
        date: routeQuery.date,
        status: routeQuery.status
      }, val => {
        statusData(val, "status");
      });
    }

    function statusData(val, type) {
      if (type == "num") {
        //删除储值总额
        val.shift();
        numList.forEach((e, i) => {
          e.total = val[i];
        });
      } else {
        statusList.forEach((e, i) => {
          e.total = val[i];
        });
      }

      console.log(numList);
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_badge = _resolveComponent("el-badge");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_main = _resolveComponent("el-main");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: add
        }, {
          default: _withCtx(() => [_createTextVNode("单个用户储值")]),
          _: 1
        })), [[_directive_auth, _ctx.getCurCode('ADD')]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: openImport
        }, {
          default: _withCtx(() => [_createTextVNode("批量用户储值")]),
          _: 1
        })), [[_directive_auth, _ctx.getCurCode('ADDS')]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: openCard
        }, {
          default: _withCtx(() => [_createTextVNode("储值卡管理")]),
          _: 1
        })), [[_directive_auth, _ctx.getCurCode('CARDS')]])]), _createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: outTime.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => outTime.value = $event),
              onChange: searchOutTime,
              placeholder: "过期时间排序",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(outTimeOptions.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: date.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => date.value = $event),
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              "value-format": "YYYY-MM-DD",
              onChange: searchDate
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: phone.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => phone.value = $event),
              "onKeyup[native]": searchPhone,
              onChange: searchPhone,
              placeholder: "手机号",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: reason.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => reason.value = $event),
              "onKeyup[native]": searchReason,
              onChange: searchReason,
              placeholder: "说明",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: remark.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => remark.value = $event),
              "onKeyup[native]": searchRemark,
              onChange: searchRemark,
              placeholder: "备注",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_col, {
              key: index,
              span: 8
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                onClick: $event => openMoneyList(item.sel),
                class: _normalizeClass({
                  td_money_item: true,
                  td_money_item_sel: item.sel
                })
              }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.label), 1), _createElementVNode("h2", null, _toDisplayString(item.total), 1)], 10, _hoisted_4)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        }), _createElementVNode("div", _hoisted_6, [_createVNode(StatusBar, {
          data: statusList,
          default: "all"
        }, null, 8, ["data"])]), _createElementVNode("div", _hoisted_7, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          text: "",
          onClick: delRefuseData
        }, {
          default: _withCtx(() => [_createTextVNode("删除未通过记录")]),
          _: 1
        })), [[_directive_auth, _ctx.getCurCode('DELETED')]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          text: "",
          onClick: exportData
        }, {
          default: _withCtx(() => [_createTextVNode("导出")]),
          _: 1
        })), [[_directive_auth, _ctx.getCurCode('EXPORT')]])]), _createVNode(_component_el_tabs, {
          modelValue: type.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => type.value = $event),
          class: "stored_order_tabs",
          onTabChange: tabChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            name: "deposit"
          }, {
            label: _withCtx(() => [_createVNode(_component_el_badge, null, {
              default: _withCtx(() => [_hoisted_8]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            name: "freeze"
          }, {
            label: _withCtx(() => [_createVNode(_component_el_badge, null, {
              default: _withCtx(() => [_hoisted_9]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), type.value === 'freeze' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(DataCollectTable, {
          data: data.value,
          config: freezeConfig,
          total: total.value,
          onOperationsHander: _unref(opHander).receive
        }, null, 8, ["data", "total", "onOperationsHander"])])), [[_directive_auth, _ctx.getCurCode('LIST')]]) : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(DataCollectTable, {
          data: data.value,
          config: depositConfig,
          total: total.value,
          onOperationsHander: _unref(opHander).receive
        }, null, 8, ["data", "total", "onOperationsHander"])])), [[_directive_auth, _ctx.getCurCode('FREEZE')]]), _createVNode(_component_el_dialog, {
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => dialogVisible.value = $event),
          title: "单个用户储值",
          width: "35%",
          top: "20vh",
          class: "base_dialog",
          onOpen: _cache[17] || (_cache[17] = $event => resetForm(formRef.value))
        }, {
          footer: _withCtx(() => [_createElementVNode("span", _hoisted_12, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[14] || (_cache[14] = $event => submitForm(formRef.value))
          }, {
            default: _withCtx(() => [_createTextVNode("提交")]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: _cache[15] || (_cache[15] = $event => dialogVisible.value = false)
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          })])]),
          default: _withCtx(() => [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form,
            rules: rules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "用户手机号",
              prop: "phone"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.phone,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.phone = $event),
                placeholder: "请输入用户手机号"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "储值金额",
              prop: "changeMoney"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: form.changeMoney,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.changeMoney = $event),
                modelModifiers: {
                  number: true
                },
                placeholder: "单位元。正数为增加，负数为减少",
                precision: 2,
                controls: false,
                "controls-position": "right"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "金额类型",
              prop: "depositType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: form.depositType,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.depositType = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: "1048001"
                }, {
                  default: _withCtx(() => [_createTextVNode("可用金额")]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: "1048002"
                }, {
                  default: _withCtx(() => [_createTextVNode("冻结金额")]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "姓名/单位",
              prop: "persionName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.persionName,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.persionName = $event),
                clearable: "",
                placeholder: "请输入姓名或单位名称",
                resize: "none"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "摘要",
              prop: "changeReason"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.changeReason,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.changeReason = $event),
                type: "textarea",
                clearable: "",
                placeholder: "用户展示",
                resize: "none"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "remark"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.remark,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.remark = $event),
                type: "textarea",
                clearable: "",
                placeholder: "后台展示",
                resize: "none"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "失效日期"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.depositExpireTime,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.depositExpireTime = $event),
                type: "date",
                placeholder: "若不填，无失效日期，可以为2099-12-31日",
                "value-format": "YYYY-MM-DD",
                clearable: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]);
    };
  }

};